// Política de Identificación del Paciente: reglas compartidas por Pacientes.js
// y CrearPacienteDialog.js (Nuevo Turno → paciente no encontrado), para que las
// dos vías de alta de un paciente exijan exactamente lo mismo.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validarCamposPaciente(form) {
  const errores = {};
  if (!form.nombre || !form.nombre.trim()) errores.nombre = 'El nombre es obligatorio';
  if (!form.apellido || !form.apellido.trim()) errores.apellido = 'El apellido es obligatorio';
  if (!form.dni || !form.dni.trim()) errores.dni = 'El DNI es obligatorio';
  else if (!/^\d{6,9}$/.test(form.dni.trim())) errores.dni = 'El DNI debe ser numérico, de 6 a 9 dígitos';
  if (!form.fecha_nacimiento) errores.fecha_nacimiento = 'La fecha de nacimiento es obligatoria';
  else if (new Date(form.fecha_nacimiento) > new Date()) errores.fecha_nacimiento = 'No puede ser una fecha futura';
  if (!form.telefono || !form.telefono.trim()) errores.telefono = 'El teléfono es obligatorio';
  else if (form.telefono.trim().replace(/\D/g, '').length < 6) errores.telefono = 'El teléfono no es válido';
  if (!form.email || !form.email.trim()) errores.email = 'El email es obligatorio';
  else if (!EMAIL_RE.test(form.email.trim())) errores.email = 'El email no es válido';
  return { valido: Object.keys(errores).length === 0, errores };
}
